<div
  #modalContents
  class="l-modal02__contents u-modal-size-pc-1000 js-modal-contents"
  aria-modal="true"
  role="dialog"
  aria-labelledby="modalTitle"
>
  <div #modalHead class="l-modal02__header js-modal-head">
    <!-- モーダルヘッダー -->
    <div class="p-modal-head02">
      <h1 id="modalTitle" class="p-modal-head02__title" [innerHTML]="'label.selectFare.title' | staticMsg"></h1>
      <button
        id="fare-family-selector-modal-close-btn"
        class="p-modal-head02__close js-modal-close"
        (click)="this.closeModal()"
      >
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
  </div>

  <!-- モーダルボディ -->
  <div #modalBody class="l-modal02__body js-modal-body">
    <!-- 注意喚起エリア -->
    <!-- モーダル上部 フライトサマリと同様箇所遅延情報 ～ 運航キャリア名称 -->
    <div class="p-modal-flight-plan">
      <asw-flight-plan
        [isSelected]="false"
        [flightSummary]="this.settingFlightSummary"
        [boundIndex]="this.settingFlightSummary.boundIndex ?? 0"
        [isOpenFlightDetail]="false"
        [isDisplayDetailLink]="false"
        [isShowGovernmentApproval]="false"
        [isShowLabelFromAcv]="false"
        [isShowWiFiService]="false"
      >
      </asw-flight-plan>
    </div>
    <div class="p-modal-body02">
      <ng-container *ngIf="this.isPromotionApplied">
        <div class="p-modal-body02__item p-modal-body02__item--promotion" aria-hidden="true">
          <span class="c-promotion-applied">
            <img
              class="c-promotion-applied__img"
              src="assets/images/icon_promotion_applied_20.svg"
              width="20"
              height="20"
            />
            <span class="c-promotion-applied__text" [innerHTML]="'label.promotionApplied' | staticMsg"></span>
          </span>
        </div>
      </ng-container>
      <button
        id="fare-family-scroll-left-btn"
        class="l-carousel01__arrow l-carousel01__arrow--prev"
        [ngClass]="{ 'is-available': isRightClicked || (!hideLeftBtn && isRightClicked) }"
        [attr.aria-label]="'alt.switchToLeftScreen' | staticMsg"
        (throttleClick$)="leftSlider()"
        aswThrottleClick
      >
        <img
          src="assets/images/btn_arrow_prev_36.svg"
          width="36"
          height="36"
          alt="{{ 'alt.switchToLeftScreen' | staticMsg }}"
          aria-hidden="true"
        />
      </button>
      <asw-common-slider id="fare-family-selector-modal-slider" [isFFModalSlider]="true">
        <div class="p-fare-panel" #scrollPanel>
          <ng-container *ngFor="let fareFamiliesInfo of this.fareFamiliesInfoList; index as ffIndex; count as ffCount">
            <!-- FF選択モーダル FF情報 以降を表示 -->
            <asw-fare-family-selector-modal-item
              [id]="
                getTealiumTSFFModalListId(this.settingFlightSummary.boundIndex ?? 0, this.travelSolutionIndex, ffIndex)
              "
              [slideNum]="ffIndex"
              [slideMax]="ffCount"
              [fareFamiliesInfo]="fareFamiliesInfo"
              [travelSolutionsFlightsList]="this.travelSolutionsFlightsList"
              [airOffersFlightsList]="this.airOffersFlightsList[ffIndex]"
              [airOfferBounds]="this.airOfferBounds[ffIndex]"
              [upgradeInfo]="fareFamiliesInfo.upgradeInfo"
              [anaCouchIsEnabledFlightIndexList]="this.anaCouchIsEnabledFlightIndexList"
              [upgradeDetailInforParam]="this.upgradeDetailInforParam"
              [boundIndex]="this.settingFlightSummary.boundIndex ?? 0"
              [travelSolutionIndex]="this.travelSolutionIndex"
              [tripTypeList]="this.tripTypeList"
              (clickSelectEvent)="
                this.clickFareFamilySelectButton(
                  this.settingFlightSummary.boundIndex!,
                  this.settingFlightSummary.travelSolutionId!,
                  fareFamiliesInfo.fareFamilyCode!
                )
              "
              (changeAllUpgradeLink)="changeLinkDisabled($event)"
            ></asw-fare-family-selector-modal-item>
          </ng-container>
        </div>
      </asw-common-slider>
      <button
        id="fare-family-scroll-right-btn"
        class="l-carousel01__arrow l-carousel01__arrow--next"
        [ngClass]="{ 'is-available': !hideRightBtn }"
        [attr.aria-label]="'alt.switchToRightScreen' | staticMsg"
        (throttleClick$)="rightSlider()"
        aswThrottleClick
      >
        <img
          src="assets/images/btn_arrow_next_36.svg"
          width="36"
          height="36"
          alt="{{ 'alt.switchToRightScreen' | staticMsg }}"
          aria-hidden="true"
        />
      </button>
    </div>
  </div>
  <div class="l-modal02__footer js-modal-footer">
    <div class="p-modal-foot01"></div>
  </div>
</div>
